module.exports = {
  dish1: {
    name: "Sushi 1",
    description: "Insert Sushi 1 description",
    price: 4000,
    status: "available"
  },
  dish2: {
    name: "Sushi 2",
    description: "Insert Sushi 2 description",
    price: 4200,
    status: "available"
  },
  dish3: {
    name: "Sushi 3",
    description: "Insert Sushi 3 description",
    price: 3200,
    status: "available"
  },
  dish4: {
    name: "Sushi 4",
    description: "Insert Sushi 4 description",
    price: 3400,
    status: "available"
  },
  dish5: {
    name: "Sushi 5",
    description: "Insert Sushi 5 description",
    price: 3500,
    status: "available"
  },
  dish6: {
    name: "Sushi 6",
    description: "Insert Sushi 6 description",
    price: 3000,
    status: "unavailable"
  },
  dish7: {
    name: "Sushi 7",
    description: "Insert Sushi 7 description",
    price: 2800,
    status: "available"
  },
  dish8: {
    name: "Sushi 8",
    price: 4400,
    description: "Insert Sushi 8 description",
    status: "available"
  },
  dish9: {
    name: "Sushi 9",
    price: 3300,
    description: "Insert Sushi 9 description",
    status: "available"
  },
  dish10: {
    name: "Sushi 10",
    price: 3900,
    description: "Insert Sushi 10 description",
    status: "available"
  }
};



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores-menus/Yum.js